<template>
  <div id="ProductDetailPage">
    <NavBar ref="test"/>
    <v-main class="third-bg" v-if="isContentLoaded">
      <div class=" third-bg py-15">
        <div class="container-fluid container-md ">
          <div class="row bg-white mx-1 mx-md-0 position-relative">
            <div class="col-md-4 dark-gray-bg">
              <!--              <v-img :src="$replaceHttps(productDetail.MainOriginalFileUrl)" contain height="200">
                            </v-img>-->
              <zoom-on-hover :img-normal="$replaceHttps(mainPic)" :scale="2" class="rounded-lg"></zoom-on-hover>
            </div>
            <div class="col-md-8 d-flex flex-column pl-1">
              <h1 class="pt-3">{{ productDetail.Name }}</h1>
              <div class="mt-4">
                <span class="font-weight-bold ">دسته بندی:</span> <span>{{ productDetail.ProductCategory.Name }}</span>
              </div>
              <div class="d-flex my-4">
                <div :class="(productDetail.DiscountPercent  !== 0 )  ? '' : 'visibility-hidden'" class="ml-3 pt-1">
                  <div :class="(productDetail.Price !== 0 )  ? '' : 'visibility-hidden'">
                    {{ $computingPriceOffer(productDetail.Price, productDetail.DiscountPercent) }} تومان
                  </div>
                </div>
                <div v-if="productDetail.Price !== 0"
                     :class="productDetail.DiscountPercent  === 0 ?'' : 'text-decoration-line-through font-12 grey--text pt-1'">
                  {{ $numberWithCommas(productDetail.Price) }} تومان
                </div>
                <span v-if="productDetail.Price === 0"> رایگان</span>

              </div>
              <div v-if="productDetail.VisitCount !== 0">
                <span class="font-weight-bold ">تعداد بازدید:</span> <span>{{ productDetail.VisitCount }}</span>
              </div>
              <div class="mt-auto">
                <v-btn color="secondary" elevation="0" @click="addToCart(productDetail.ProductId)">
                  افزودن به سبد خرید
                  <i class="fa-solid fa-cart-circle-plus primary-text mr-2"></i>
                </v-btn>
              </div>
            </div>
            <span v-if="productDetail.DiscountPercent !== 0"
                  class="red white--text px-2 rounded position-absolute mt-2 mr-2">
           {{ productDetail.DiscountPercent }} %
        </span>
          </div>
          <div v-if="productDetail.AparatVideo !== null && productDetail.AparatVideo !== 'null'" class="row">
            <div class="col-12">
              <div v-html="productDetail.AparatVideo"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <v-tabs
                  v-model="tabs">
                <v-tab
                    href="#0">
                  توضیحات
                </v-tab>
                <v-tab
                    href="#1">
                  گالری
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item value="0">
                  <v-card flat>
                    <v-card-text class="p-0">
                      <div class="container-fluid container-md">
                        <div class="row">
                          <div class="col-12" v-html="productDetail.Description">
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="1">
                  <v-card flat>
                    <v-card-text class="p-0">
                      <div class="container-fluid container-md">
                        <div class="row">
                          <!--      <div v-for="(item,i) in productInfo.gallery" :key="i" class="col-6 col-md-4 col-lg-3">
                                  <div>
                                    <v-img :src="$replaceHttps(item.originalSrc)" class="third-bg rounded" contain
                                           height="150"></v-img>
                                  </div>
                           </div>-->
                          <silent-box :gallery="productInfo.gallery" id="silentBox"></silent-box>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
          <div class="row bg-white mx-1">
            <div class="col-auto mx-auto  font-16">
              <div class="border-bottom-gold pb-2 px-5 font-18">
                محصولات مشابه
              </div>
            </div>
            <div class="col text-left">
              <v-btn :to="{path:'allProducts'}" color="primary" outlined>
                مشاهده بیشتر
              </v-btn>
            </div>
            <div
                v-if="similarProducts !== null && similarProducts !== undefined && similarProducts.length > 0"
                class="col-12 "
                dir="ltr">
              <carousel
                  :autoplay="true"
                  :dots="false"
                  :items="4"
                  :loop="false"
                  :margin="15"
                  :nav="false"
                  :responsive="{0:{items:1,nav:false},750:{items:2,nav:false}
                      ,1200:{items:3,nav:false}}"
                  :rtl="true"
                  class="py-0 ">
                <div v-for="item in similarProducts" :key="item.ProductId" dir="rtl">
                  <ProductsCard :item="item"/>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
      <v-dialog
          v-model="showResultDialog"
          hide-overlay
          persistent
          width="530">
        <v-card class="text-center">
          <v-card-title class="justify-space-between secondary-bg">
            <v-btn
                color="primary"
                icon
                @click="showResultDialog = false">
              <i class="fas fa-times ml-1"></i>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-6">
            <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-overlay
          v-model="showLoaderDialog"
          persistent
          width="500">
        <v-progress-circular
            color="white"
            indeterminate
            size="50"
        ></v-progress-circular>
      </v-overlay>
    </v-main>
    <FooterComponent/>
  </div>
</template>

<script>

import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";
import carousel from "vue-owl-carousel";
import ProductsCard from "@/Academy/components/ProductsCard";

export default {
  name: "ProductDetail",
  metaInfo () {
    return {
      title: window.projectName + this.title,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar, ProductsCard, carousel},

  data: () => ({
    tabs: null,
    showLoaderDialog: false,
    books: [],
    similarProducts: [],
    productDetail: {},
    productInfo: {},
    mainPic: "",
    showResultDialog: false,
    isContentLoaded: false,
    dialogResult: null,
    title: null,
  }),
  mounted() {
    this.getData()
  },

  watch: {
    '$route.query.productId'() {
      location.reload()
    }
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ProductDetail?productId=" + this.$route.query.productId, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.productInfo = json
            this.productDetail = json.product
            this.title = json.product.Name
            this.mainPic = json.product.MainOriginalFileUrl;
            let gallery = [];
            if (json.product.Gallery1OriginalFileUrl !== null) {
              gallery.push({
                src: json.product.Gallery1OriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            if (json.product.Gallery2OriginalFileUrl !== null) {
              gallery.push({
                src: json.product.Gallery2OriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            if (json.product.Gallery3OriginalFileUrl !== null) {
              gallery.push({
                src: json.product.Gallery3OriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            /*
            if (json.product.Gallery3OriginalFileUrl !== null) {
              gallery.push({
                originalSrc: json.product.Gallery3OriginalFileUrl,
                mediumSrc: json.product.Gallery3FileUrl400,
                smallSrc: json.product.Gallery3FileUrl200
              });
            }*/
            if (json.product.Gallery4OriginalFileUrl !== null) {
              gallery.push({
                src: json.product.Gallery4OriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            if (json.product.Gallery5OriginalFileUrl !== null) {
              gallery.push({
                src: json.product.Gallery5OriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            if (json.product.MainOriginalFileUrl !== null) {
              gallery.push({
                src: json.product.MainOriginalFileUrl,
                description: '',
                alt: '',
                thumbnailWidth: '220px',
                thumbnailHeight: '220px',
              });
            }
            json.gallery = gallery;
            this.similarProducts = json.similarProducts
            this.showLoaderDialog = false
            this.isContentLoaded = true
          })
          .catch(error => console.log('error', error));
    },
    addToCart(id) {
      let resStatus = null
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("productId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/AddProductToCart", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          }).then(result => {
        if (resStatus === 401) {
          this.showResultDialog = true
          this.dialogResult = 'برای اضافه کردن محصول به سبد خرید ابتدا باید وارد سایت شوید.'
        }
        if (resStatus === 200) {
          this.showResultDialog = true
          this.dialogResult = result

          setTimeout(function () {
            window.location.reload();
          }, 1000);

        }

      })
          .catch(error => console.log('error', error));

    }
  }
}
</script>

<style scoped>

</style>
